/**
 * validateRequired — перевірка обов'язкових полів ПЕРЕД мутацією.
 *
 * Запобігає тому, що backend 422 повертав масив помилок,
 * фронт виводив `[object Object]` або «біла сторінка».
 *
 * Використання:
 *   const err = validateRequired({ code: form.code, name: form.name });
 *   if (err) { setError(err); return; }
 *   mutation.mutate();
 */
type Rule = string | number | null | undefined;

export function validateRequired(
  fields: Record<string, Rule>,
  labels: Record<string, string> = {},
): string | null {
  const missing: string[] = [];
  for (const [key, value] of Object.entries(fields)) {
    const empty =
      value === null ||
      value === undefined ||
      (typeof value === 'string' && value.trim() === '') ||
      (typeof value === 'number' && Number.isNaN(value));
    if (empty) {
      missing.push(labels[key] ?? key);
    }
  }
  if (missing.length === 0) return null;
  return `Заповніть обов'язкові поля: ${missing.join(', ')}`;
}
